export const eventLiveAction = `<svg viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28 20C28 23.866 24.866 27 21 27H15C12.2386 27 10 24.7614 10 22C10 19.2386 12.2386 17 15 17H28V20Z" fill="currentColor"/>
<path d="M28 7C28 10.866 24.866 14 21 14H8C5.23858 14 3 11.7614 3 9C3 6.23858 5.23858 4 8 4H28V7Z" fill="currentColor"/>
</svg>`;
